import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchComponent } from '@enginuity/core/molecules/search/search.component';
import { ContentTypeComponent } from '../content-type/content-type.component';
import { IconContainerComponent } from '@enginuity/core/atoms/icon-container/icon-container.component';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss'],
  imports: [CommonModule, SearchComponent, ContentTypeComponent, IconContainerComponent],
})
export class CustomersComponent {
  @Input()
  selectedCustomer: string = '';

  @Output() selectionChanged = new EventEmitter<string>();
  @Output() onClick = new EventEmitter<any>();

  @Input()
  state: string = '';

  @Input()
  title: string = '';

  @Input()
  customers = [{ name: '', email: '' }];

  onItemSelected(selectedValue: string) {
    this.selectedCustomer = selectedValue;
    this.selectionChanged.emit(selectedValue);
  }
}
